import { absolutePath } from "./absolutePath";

export const upcomingEvents = {
  index: () => absolutePath("upcoming_events"),
};
